module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-center-e2d8c7c5d293b7bc11a30a2cdc25cb10.svg";